import get from 'transmute/get';
export const getHasBillingRead = user => get('scopes', user).includes('billing-read');